import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useLevel } from '../context/LevelContext';
import { buildLevelPath } from '../utils/routeLanguage';

export const LandingPage = () => {
  const { t, language, toggleLanguage } = useLanguage();
  const { selectedLevel } = useLevel();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [requires2FA, setRequires2FA] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const levelPath = buildLevelPath(language, selectedLevel);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(email, password, twoFactorCode);

      if (response?.requires2FA) {
        setRequires2FA(true);
        setLoading(false);
        return;
      }

      navigate(levelPath);
    } catch (err) {
      setError(err.response?.data?.error || t('loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <section className="landing-hero">
        <div className="landing-hero-content">
          {/* Badge */}
          <div className="landing-badge">
            {t('platformBadge')}
          </div>

          {/* Title */}
          <h1 className="landing-title">
            Lingua<span className="accent">DE</span>
          </h1>

          {/* Subtitle */}
          <p className="landing-subtitle">
            {t('subtitle')}
          </p>



          {/* Login Form */}
          <div className="landing-form-container">
            {error && (
              <div className="landing-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="landing-form-group">
                <label className="landing-form-label">{t('email')}</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('emailPlaceholder')}
                  className="landing-form-input"
                  required
                  disabled={requires2FA}
                />
              </div>

              <div className="landing-form-group">
                <label className="landing-form-label">{t('password')}</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t('passwordPlaceholder')}
                  className="landing-form-input"
                  required
                  disabled={requires2FA}
                />
              </div>

              {requires2FA && (
                <div className="landing-form-group">
                  <label className="landing-form-label">
                    {t('twoFactorCode')}
                  </label>
                  <input
                    type="text"
                    value={twoFactorCode}
                    onChange={(e) => setTwoFactorCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    placeholder="000000"
                    maxLength={6}
                    className="landing-form-input"
                    style={{ textAlign: 'center', letterSpacing: '8px', fontSize: '18px' }}
                    required
                    autoFocus
                  />
                  <p className="landing-2fa-note">
                    {t('enterAuthCode')}
                  </p>
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="landing-form-button"
              >
                {loading ? t('loading') : t('login')}
              </button>
            </form>

            <div className="landing-divider" />

            <div className="landing-form-footer">
              {t('registrationTemporarilyUnavailable')}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
